module.exports = "<div class=\"main\">\r\n\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"